module.exports = __webpack_public_path__ + "img/hellas-verona-logo-icon.862b6fdd.png";